(() => {
  const configEl = document.getElementById('tw-free-gift-config');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  const code = String(config.code || '').toUpperCase();
  const giftVariantId = Number(config.giftVariantId);
  const triggerIds = (config.triggerProductIds || []).map(Number);
  if (!code || !giftVariantId || !triggerIds.length) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let busy = false;
  let pending = false;

  const readCookie = (name) => {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  };

  const storageKey = 'tw-free-gift-blocked';
  const readStorage = () => {
    try {
      return sessionStorage.getItem(storageKey) || '';
    } catch (e) {
      return '';
    }
  };
  const writeStorage = (value) => {
    try {
      sessionStorage.setItem(storageKey, value);
    } catch (e) {}
  };

  const hasCode = (cart) =>
    (cart.discount_codes || []).some((d) => String(d.code || '').toUpperCase() === code);

  // Een /discount/<CODE>-link zet de code in een cookie; bestond de winkelwagen al (Intelligems
  // maakt hem bij binnenkomst aan), dan staat de code er niet op. Zet hem er dan zelf op,
  // naast eventuele andere codes.
  const applyCookieCode = async (cart) => {
    if (hasCode(cart) || readCookie('discount_code').toUpperCase() !== code) return cart;
    const codes = (cart.discount_codes || []).map((d) => d.code).concat(code);
    return post('cart/update.js', { discount: codes.join(',') });
  };

  const isGiftLine = (item) => item.properties && item.properties._tw_gift;

  const post = (path, body) =>
    fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => r.json());

  const refreshView = () => {
    if (config.isCartPage) {
      window.location.reload();
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  };

  const sync = async () => {
    if (busy) {
      pending = true;
      return;
    }
    busy = true;
    try {
      const cart = await applyCookieCode(
        await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json())
      );
      const triggerLines = cart.items.filter((item) => triggerIds.includes(Number(item.product_id)) && !isGiftLine(item));
      const giftLines = cart.items.filter(isGiftLine);
      // Een andere korting (bijvoorbeeld de bundelkorting bij twee stuks) kan de cadeaukorting
      // blokkeren. Dan halen we het cadeau weg en proberen het pas opnieuw als de winkelwagen verandert.
      const signature = triggerLines.map((item) => item.key + ':' + item.quantity).join('|');
      const blocked = readStorage() === signature;
      const shouldHaveGift = triggerLines.length > 0 && hasCode(cart) && !blocked;
      let changed = false;

      if (shouldHaveGift && giftLines.some((item) => item.final_line_price > 0)) {
        const updates = {};
        giftLines.forEach((item) => (updates[item.key] = 0));
        await post('cart/update.js', { updates });
        writeStorage(signature);
        changed = true;
      } else if (shouldHaveGift && giftLines.length === 0) {
        await post('cart/add.js', { items: [{ id: giftVariantId, quantity: 1, properties: { _tw_gift: '1' } }] });
        const after = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        const notFree = after.items.filter((item) => isGiftLine(item) && item.final_line_price > 0);
        if (notFree.length) {
          const updates = {};
          notFree.forEach((item) => (updates[item.key] = 0));
          await post('cart/update.js', { updates });
          writeStorage(signature);
        }
        changed = true;
      } else if (shouldHaveGift && (giftLines.length > 1 || giftLines[0].quantity !== 1)) {
        const updates = {};
        giftLines.forEach((item, i) => (updates[item.key] = i === 0 ? 1 : 0));
        await post('cart/update.js', { updates });
        changed = true;
      } else if (!shouldHaveGift && giftLines.length > 0) {
        const updates = {};
        giftLines.forEach((item) => (updates[item.key] = 0));
        await post('cart/update.js', { updates });
        changed = true;
      }

      if (changed) refreshView();
    } catch (e) {
      // De actie mag de winkelwagen nooit blokkeren.
    } finally {
      busy = false;
      if (pending) {
        pending = false;
        sync();
      }
    }
  };

  document.addEventListener('cart:change', () => sync());
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) sync();
  });
  sync();
})();
